import { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import HeroSlider from '../components/HeroSlider';
import ServicesSection from '../components/ServicesSection';
import ProjectsSection from '../components/ProjectsSection';
import PartnerCarousel from '../components/PartnerCarousel';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import LoadingScreen from '../components/LoadingScreen';
import BuilderPackages from "../components/BuilderPackages";
import WhatsAppButton from "../components/WhatsAppButton"

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COMPANIES = [

    {
    id: 'architects',
    name: 'Ananthameenakshi Architects',
    slug: 'architecture',
    tagline: 'Premium Design Plans & Service',
    description: 'Award-winning architectural design and consulting services',
    image: 'https://images.unsplash.com/photo-1542621334-a254cf47733d?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },

  {
    id: 'builders',
    name: "Ananthameenakshi & Sriram Associates ",
    slug: 'builder',
    tagline: 'Building Tomorrow\'s Landmarks',
    description: 'Premier construction services delivering exceptional quality and craftsmanship.',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&q=80',
  },
   {
    id: 'materials',
    name: 'Ananthameenakshi & Meenakshi Agency',
    slug: 'materials',
    tagline: 'Premium Construction Materials',
    description: 'Top-grade construction materials with unmatched quality.',
    image: 'https://images.unsplash.com/photo-1763771421320-028cdbade96d?q=80&w=1177&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  {
    id: 'developers',
    name: 'Ananthameenakshi Developers',
    slug: 'developers',
    tagline: 'Visionary Developers & Housing',
    description: 'More Than Homes, We Build Communities',
    image: 'https://newprojects.99acres.com/projects/build_own_developers/build_own_moon_valley/images/aymybbd_1697008033_450356168_large.jpg',
  },
 

 
   
];

export default function HomePage() {
  const [activeCompany, setActiveCompany] = useState(0);
  const [services, setServices] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLoading, setShowLoading] = useState(true);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, projectsRes] = await Promise.all([
          axios.get(`${API}/services`),
          axios.get(`${API}/projects`),
        ]);
        setServices(servicesRes.data);
        setProjects(projectsRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const currentCompany = COMPANIES[activeCompany];
  const filteredServices = services.filter(s => s.company_slug === currentCompany.slug);
  const filteredProjects = projects.filter(p => p.company_slug === currentCompany.slug);
  

  return (
    <>
      {showLoading && <LoadingScreen onLoadingComplete={() => setShowLoading(false)} />}
    <div data-testid="homepage" className="min-h-screen bg-obsidian overflow-x-hidden">
      <Navbar activeCompany={currentCompany} />
      
      <HeroSlider
        companies={COMPANIES}
        activeIndex={activeCompany}
        setActiveIndex={setActiveCompany}
      />
      <WhatsAppButton />
      <ServicesSection 
        services={filteredServices} 
        companyName={currentCompany.name}
        loading={loading}
      />
      
      <ProjectsSection 
        projects={filteredProjects} 
        companyName={currentCompany.name}
        companyId={currentCompany.id}
        loading={loading}
      /> 

      {currentCompany.slug === "materials" && (
      <PartnerCarousel/>
      )}

      <AboutSection />

      {(currentCompany.slug === "builder"||currentCompany.slug==="architecture") && (
      <BuilderPackages currentCompany={currentCompany}
        />
      )}

      <ContactSection />
      
      <Footer /> 
    </div>
    </>
  );
}
